import clsx from 'clsx';
import { ComponentPropsWithoutRef } from 'react';

import Icon from '@/components/base/Icon';

const TagStyle = {
    default: 'bg-icoBlue-100 dark:bg-icoBlue/20 text-icoBlue rounded-2xl p-2.5 h-8',
    album: 'bg-icoBlue text-white rounded-2xl p-2.5',
    role: 'rounded-m py-1 px-2',
    autopost: 'bg-icoYellow-100 dark:bg-icoYellow/20 text-icoYellow rounded-sm py-1 px-2',
    hashtag_list: 'rounded-m px-2 py-1 bg-icoBlue-100 dark:bg-icoBlue/20 text-icoBlue',
    caption: 'rounded-m px-2 py-1 bg-pink-100 dark:bg-pink-500/20 text-pink-500',
    media: 'bg-icoBlack/20 backdrop-blur-20 text-white rounded-full p-2',
    disabled:
        'bg-icoGray-100 dark:bg-icoDarkMode-deepBlack text-icoGray-500 dark:text-icoDarkMode-wolf cursor-not-allowed rounded-2xl p-2.5 h-8',
    'square-small': 'rounded-m py-1 px-2',
    rounded: 'rounded-full py-1 px-2',
    option_blue:
        'bg-icoBlue-100 dark:bg-icoBlue/20 text-icoBlue rounded-full px-2 h-6 border border-icoBlue-200',
    option_gray:
        'bg-icoGray-100 dark:bg-icoDarkMode-deepBlack text-icoGray-500 rounded-full px-2 h-6 border border-icoGray-300 dark:border-icoDarkMode-beton',
    option_disabled:
        'bg-icoGray-100 dark:bg-icoDarkMode-deepBlack text-icoGray-500 rounded-full px-2 h-6',
    option_transparent:
        'bg-transparent text-icoGray-500 rounded-full px-2 h-6 border border-icoGray-300 dark:border-icoDarkMode-beton'
};

const RoleVariants = {
    manager: 'bg-icoPurple-100 text-icoPurple dark:bg-icoPurple/20',
    team_member: 'bg-icoBlue-100 text-icoBlue dark:bg-icoBlue/20',
    admin: 'bg-icoGreen-100 text-icoGreen dark:bg-icoGreen/20'
};

type ActionTagPropsType = ComponentPropsWithoutRef<'div'> & {
    variant?: keyof typeof TagStyle;
    role?: keyof typeof RoleVariants;
    icon?: string;
    afterIcon?: string;
    iconFn?: () => void;
};

const ActionTag = ({
    variant = 'default',
    role,
    className,
    icon,
    afterIcon,
    iconFn,
    children,
    ...restProps
}: ActionTagPropsType) => {
    return (
        <div
            className={clsx(
                'flex items-center text-xs',
                TagStyle[variant],
                RoleVariants[role ?? ''],
                className
            )}
            {...restProps}>
            {icon ? <Icon icon={icon} className="mr-1" /> : null}
            {children}
            {afterIcon ? (
                <Icon
                    icon={afterIcon}
                    className={clsx('ml-2', {
                        'cursor-pointer': iconFn
                    })}
                    onClick={() => {
                        if (typeof iconFn === 'function') {
                            iconFn();
                        }
                    }}
                />
            ) : null}
        </div>
    );
};

export default ActionTag;
